<template>
  <div class="m-wrap m-wap">
    <Logo />
    <Banner />
    <!-- <div class="venue">
      <a
        v-if="extraItem.extras('signupfont.model').length > 0"
        v-show="formInfo.identity == 1"
        @click="togoVerify"
        class="goto-venue font"
      >
        {{ extras | extra("signupfont.model") }}
      </a>
    </div> -->
    <!--<div class="logo">-->
    <!--<img src="../../assets/images/wap/logo.png" alt="" />-->
    <!--</div>-->
    <!--<div class="banner">-->
    <!--<img src="../../assets/images/wap/banner.png" alt="" />-->
    <!--</div>-->
    <div class="over-box" v-if="isTrackClosedMessage">
      <FormStatus :status="'over'" :platform="platform"></FormStatus>
      <a-button
        class="btn-default"
        v-show="formInfo.identity == 1"
        v-if="extraItem.extras('signupfont.model').length > 0"
        @click="togoVerify()"
      >
        {{ extras | extra("signupfont.model") }}
      </a-button>
    </div>
    <div v-else-if="preview || formInfo.status == 1">
      <h4
        class="title"
        :style="{
          color: extraItem.extras('titlefont.color'),
          fontSize: pxOrVw(extraItem.extras('titlefont.size')),
          fontWeight:
            extraItem.extras('titlefont.weight') == 'default'
              ? '500'
              : extraItem.extras('titlefont.weight'),
        }"
        v-if="extraItem.extras('titlefont.display') == 1"
      >
        {{ formInfo.title }}
      </h4>
      <LangSelector />
      <div
        class="venue"
        v-show="formInfo.identity == 1"
        v-if="extraItem.extras('signupfont.model').length > 0"
      >
        <a @click="togoVerify()" class="goto-venue font">
          {{ extras | extra("signupfont.model") }}
        </a>
      </div>
      <CField
        class="field-wrap"
        :formData="formData"
        :platform="platform"
        :rulesJump.sync="rulesJump"
        ref="formRef"
      />
      <div class="bottom">
        <a-button
          class="submit"
          type="primary"
          @click="submit()"
          :disabled="isSubmitting"
        >
          {{ extras | extra("submitfont.model") }}
        </a-button>
      </div>
      <div class="bottom">
        <a-button
          class="btn-default"
          v-show="formInfo.identity == 1"
          v-if="extraItem.extras('signupfont.model').length > 0"
          @click="togoVerify()"
        >
          {{ extras | extra("signupfont.model") }}
        </a-button>
      </div>
    </div>
    <FormStatus
      v-else
      :status="formInfo.status == 0 ? 'nostart' : 'over'"
      :platform="platform"
    ></FormStatus>
    <WapMeetEntry :seminarInfo="seminarInfo" />
    <Card :tenantId="tenantId"></Card>
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import CField from "@/components/CField.vue";
import FormStatus from "@/components/FormStatus.vue";
import WapMeetEntry from "@/components/WapMeetEntry.vue";
import LangSelector from "@/components/LangSelector.vue";
import mixinMeeting from "../../mixin/meeting.js";
import mixinConfig from "../../mixin/config.js";
import mixin from "../../mixin/form.js";
import i18nMixin from "../../mixin/i18n.js";
import Card from "../../../stempcore/src/core/components/common/Card";

export default {
  name: "WapIndex",
  mixins: [mixinMeeting, mixinConfig, mixin, i18nMixin],
  components: {
    Logo,
    Banner,
    CField,
    FormStatus,
    WapMeetEntry,
    LangSelector,
    Card,
  },
  data() {
    return {
      platform: "wap",
    };
  },
};
</script>
